/**
 * Sale landing page runtime.
 *  <sale-countdown data-deadline="2026-06-05T23:59:59+05:30"> — live DD:HH:MM:SS
 *    into [data-cd-days] [data-cd-hours] [data-cd-mins] [data-cd-secs].
 *    If the deadline is absent/past, the element hides itself (sale "extended").
 *  <sale-sticky> — reveals its bar once the user scrolls past [data-after] (a
 *    selector) or a px threshold; hides again near the very top.
 */
(function () {
if (window.__saleJs) return;
window.__saleJs = true;
class SaleCountdown extends globalThis.ThemeElement {
  connectedCallback() {
    const raw = this.dataset.deadline;
    this.deadline = raw ? new Date(raw).getTime() : NaN;
    this.days = this.$('[data-cd-days]');
    this.hours = this.$('[data-cd-hours]');
    this.mins = this.$('[data-cd-mins]');
    this.secs = this.$('[data-cd-secs]');
    if (!this.deadline || isNaN(this.deadline)) { this.style.display = 'none'; return; }
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() { clearInterval(this.timer); super.disconnectedCallback(); }
  tick() {
    let diff = Math.floor((this.deadline - Date.now()) / 1000);
    if (diff <= 0) { this.style.display = 'none'; clearInterval(this.timer); return; }
    const d = Math.floor(diff / 86400); diff -= d * 86400;
    const h = Math.floor(diff / 3600); diff -= h * 3600;
    const m = Math.floor(diff / 60); const s = diff - m * 60;
    const pad = (n) => String(n).padStart(2, '0');
    if (this.days) this.days.textContent = pad(d);
    if (this.hours) this.hours.textContent = pad(h);
    if (this.mins) this.mins.textContent = pad(m);
    if (this.secs) this.secs.textContent = pad(s);
  }
}
if (!customElements.get('sale-countdown')) customElements.define('sale-countdown', SaleCountdown);

class SaleSticky extends globalThis.ThemeElement {
  connectedCallback() {
    this.bar = this.$('[data-sticky-bar]');
    const afterSel = this.dataset.after;
    this.threshold = 600;
    if (afterSel) {
      const ref = document.querySelector(afterSel);
      if (ref) this.threshold = ref.offsetTop + ref.offsetHeight - 120;
    }
    this.onScroll = globalThis.JunneTheme.throttle(() => this.update(), 120);
    this.on(window, 'scroll', this.onScroll, { passive: true });
    this.update();
  }
  update() {
    if (!this.bar) return;
    const show = window.scrollY > this.threshold;
    this.bar.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
    this.bar.style.opacity = show ? '1' : '0';
  }
}
if (!customElements.get('sale-sticky')) customElements.define('sale-sticky', SaleSticky);
})();
